import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const FAQ = () => {
  const { i18n } = useTranslation();
  const isKo = i18n.language === 'ko';
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      qKo: '🇺🇸 미국 시장 규제를 검증할 수 있나요? 🇰🇷 한국도 지원하나요?',
      qEn: 'Can I validate U.S. market compliance? Is Korea supported too?',
      aKo: '현재는 미국(FDA·FTC·MoCRA) 규제를 검증합니다. 한국(식약처) 지원은 2027년 상반기 준비 중입니다.',
      aEn: 'Today VeriPass validates U.S. rules (FDA, FTC, MoCRA). Korea (MFDS) support is in preparation for H1 2027.'
    },
    {
      qKo: '어떤 시장부터 검증해야 하나요?',
      qEn: 'Which market should I validate first?',
      aKo: '판매하려는 시장의 규제를 먼저 확인하세요. 한국에서 제조하여 미국에 수출한다면 미국 규제를 우선 확인하시면 됩니다.',
      aEn: 'Validate the market where the product will be sold first. If you manufacture in Korea and export to the U.S., start with U.S. rules.'
    },
    {
      qKo: '규제 정보는 얼마나 자주 업데이트되나요?',
      qEn: 'How often is the regulatory data updated?',
      aKo: 'FDA·FTC 등 미국 규제 기관의 변경사항을 주 단위로 모니터링하여 검증 데이터에 반영합니다.',
      aEn: 'FDA and FTC regulatory changes are monitored weekly and folded into the validation dataset.'
    },
    {
      qKo: 'EU, 일본 등 다른 시장도 지원하나요?',
      qEn: 'Do you support EU or Japan as well?',
      aKo: '현재는 미국 시장을 지원하며, 한국은 2027년 상반기 준비 중입니다. EU·일본 등은 추후 단계로 예정되어 있습니다.',
      aEn: 'VeriPass currently supports the U.S. market. Korea is in preparation for H1 2027, with EU and Japan planned in later phases.'
    },
    {
      qKo: '데이터는 어떻게 보안 관리되나요?',
      qEn: 'How do you handle data security?',
      aKo: '사용자별 데이터 격리가 이루어지며, 모든 통신은 HTTPS로 암호화됩니다. AWS 인프라 위에서 보안 모범 사례를 따릅니다.',
      aEn: 'User data is isolated per account and all traffic is encrypted over HTTPS. We follow AWS security best practices.'
    }
  ];

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section id="faq" className="section-soft" style={{ padding: '72px 0' }}>
      <div className="wrap">
        <div className="section-head">
          <h2>{isKo ? '자주 묻는 질문' : 'Frequently Asked Questions'}</h2>
        </div>
        <div className="faq-list">
          {faqs.map((faq, i) => (
            <div key={i} className={`faq-item${openIndex === i ? ' open' : ''}`}>
              <div
                className="faq-header"
                onClick={() => toggle(i)}
                role="button"
                tabIndex={0}
                aria-expanded={openIndex === i}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(i); } }}
              >
                <span>{isKo ? faq.qKo : faq.qEn}</span>
                <span className="faq-arrow">▶</span>
              </div>
              <div className="faq-body" style={{ maxHeight: openIndex === i ? '200px' : '0' }}>
                <div className="faq-body-inner">{isKo ? faq.aKo : faq.aEn}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
